// Define action types with discriminated unions
type FetchNetworkIdAction = {
  type: "FETCH_NETWORK_ID";
  data: string | null;
};

type FetchNFTContractInstanceAction = {
  type: "NFT_CONTRACT_INSTANCE";
  data: object | null;
};

interface Web3Data {
  isLoggedIn: boolean;
  accounts: string[];
}

type FetchWeb3DataAction = {
  type: "FETCH_WEB3_DATA";
  data: Web3Data;
};

type FetchWeb3DataErrorAction = {
  type: "FETCH_WEB3_DATA_ERROR";
  data: Web3Data;
};

// Define a base action for other Redux actions with proper typing
type OtherAction = {
  type: string;
  data?: unknown;  // Replace any with unknown for better type safety
};

// Union types for actions with proper type guards
type NetworkIdAction = FetchNetworkIdAction | OtherAction;
type NFTContractAction = FetchNFTContractInstanceAction | OtherAction;
type Web3DataAction = FetchWeb3DataAction | FetchWeb3DataErrorAction | OtherAction;

// Reducer functions with proper typing
export function fetchNetworkId(state: string | null = null, action: NetworkIdAction): string | null {
  switch (action.type) {
    case "FETCH_NETWORK_ID":
      return (action as FetchNetworkIdAction).data;
    default:
      return state;
  }
}

export function fetchNFTContractInstance(state: object | null = null, action: NFTContractAction): object | null {
  switch (action.type) {
    case "NFT_CONTRACT_INSTANCE":
      return (action as FetchNFTContractInstanceAction).data;
    default:
      return state;
  }
}

export function fetchWeb3Data(
  state: Web3Data = {
    isLoggedIn: localStorage.getItem("RwaAuthToken") ? true : false,
    accounts: [localStorage.getItem("userAddress") || ""],
  },
  action: Web3DataAction
): Web3Data {
  switch (action.type) {
    case "FETCH_WEB3_DATA":
      return (action as FetchWeb3DataAction).data;
    case "FETCH_WEB3_DATA_ERROR":
      return (action as FetchWeb3DataErrorAction).data;
    default:
      return state;
  }
}

// interface WalletState {
//   isWeb2User: boolean;
//   smartWalletInstance: any;
//   client: any;
// }

// Enhanced Wallet State Interface
interface WalletState {
  isWeb2User: boolean;
  smartWalletInstance: any;
  client: any;
  personalAccount: string | null;
  walletAddress: string | null;
  connectedWallet: any; // Wallet type from thirdweb
  vaultWalletData: any;
  isConnecting: boolean;
  showSendPopup: boolean;
  recipient: string;
  tokenAmount: string;
  txHash: string;
  isSending: boolean;
  walletConnectSession:any;
  walletConnectClient:any;
}

// const initialState: WalletState = {
//   isWeb2User: false,
//   smartWalletInstance: null,
//   client: null,
// };
const initialWalletState: WalletState = {
  isWeb2User: false,
  smartWalletInstance: null,
  personalAccount: null,
  client: null,
  walletAddress: null,
  connectedWallet: null,
  vaultWalletData: null,
  isConnecting: false,
  showSendPopup: false,
  recipient: '',
  tokenAmount: '',
  txHash: '',
  isSending: false,
  walletConnectSession:null,
  walletConnectClient:null,
};

// export function wallet(state = initialState, action: any): WalletState {
//   switch (action.type) {
//       case 'SET_IS_WEB2_USER':
//           return { ...state, isWeb2User: action.data };
//       case 'SET_SMART_WALLET_INSTANCE':
//           return { ...state, smartWalletInstance: action.data };
//       case 'SET_CLIENT':
//           return { ...state, client: action.data };
//       default:
//           return state;
//   }
// }

type WalletAction = 
  | { type: 'SET_IS_WEB2_USER'; data: boolean }
  | { type: 'SET_SMART_WALLET_INSTANCE'; data: any }
  | { type: 'SET_CLIENT'; data: any }
  | { type: 'SET_WALLET_ADDRESS'; data: string | null }
  | { type: 'SET_CONNECTED_WALLET'; data: any }
  | { type: 'SET_VAULT_WALLET_DATA'; data: any }
  | { type: 'SET_IS_CONNECTING'; data: boolean }
  | { type: 'SET_SHOW_SEND_POPUP'; data: boolean }
  | { type: 'SET_RECIPIENT'; data: string }
  | { type: 'SET_TOKEN_AMOUNT'; data: string }
  | { type: 'SET_TX_HASH'; data: string }
  | { type: 'SET_IS_SENDING'; data: boolean }
  | { type: 'RESET_WALLET_STATE' }
  | { type: 'SET_WALLET_CONNECT_CLIENT'; data: any }
  | { type: 'SET_WALLET_CONNECT_SESSION'; data: any }
  | { type: 'SET_PERSONAL_ACCOUNT'; data: string | null };


  export function wallet(state = initialWalletState, action: WalletAction): WalletState {
    switch (action.type) {
      case 'SET_IS_WEB2_USER':
        return { ...state, isWeb2User: action.data };
      case 'SET_SMART_WALLET_INSTANCE':
        return { ...state, smartWalletInstance: action.data };
      case 'SET_PERSONAL_ACCOUNT':
        return { ...state, personalAccount: action.data };
      case 'SET_CLIENT':
        return { ...state, client: action.data };
      case 'SET_WALLET_ADDRESS':
        return { ...state, walletAddress: action.data };
      case 'SET_CONNECTED_WALLET':
        return { ...state, connectedWallet: action.data };
      case 'SET_VAULT_WALLET_DATA':
        return { ...state, vaultWalletData: action.data };
      case 'SET_IS_CONNECTING':
        return { ...state, isConnecting: action.data };
      case 'SET_SHOW_SEND_POPUP':
        return { ...state, showSendPopup: action.data };
      case 'SET_RECIPIENT':
        return { ...state, recipient: action.data };
      case 'SET_TOKEN_AMOUNT':
        return { ...state, tokenAmount: action.data };
      case 'SET_TX_HASH':
        return { ...state, txHash: action.data };
      case 'SET_IS_SENDING':
        return { ...state, isSending: action.data };
      case 'RESET_WALLET_STATE':
        return initialWalletState;
      case 'SET_WALLET_CONNECT_CLIENT':
          return { ...state, walletConnectClient: action.data };
      case 'SET_WALLET_CONNECT_SESSION':
          return { ...state, walletConnectSession: action.data };
      default:
        return state;
    }
  }